import { Button, Paper, Stack } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { modernBookNavigationSx } from '../modern-book-styles';

const navigationItems = [
  { href: '#book-overview', labelId: 'book.modern.sections.overview.title' },
  { href: '#book-configuration', labelId: 'book.modern.sections.configuration.title' },
  { href: '#book-access', labelId: 'book.modern.sections.access.title' },
  { href: '#book-sap', labelId: 'book.modern.sections.sap.title' },
  { href: '#book-notes', labelId: 'book.modern.sections.notes.title' },
] as const;

const BookQuickNavigation = () => {
  const intl = useIntl();

  return (
    <Paper
      component="nav"
      elevation={0}
      aria-label={intl.formatMessage({ id: 'book.modern.quickNavigation' })}
      sx={modernBookNavigationSx}>
      <Stack direction="row" spacing={0.5} sx={{ width: 'max-content', minWidth: '100%' }}>
        {navigationItems.map((item) => (
          <Button
            key={item.href}
            component="a"
            href={item.href}
            size="small"
            color="inherit"
            sx={{ flexShrink: 0, px: 1.25, whiteSpace: 'nowrap' }}>
            <FormattedMessage id={item.labelId} />
          </Button>
        ))}
      </Stack>
    </Paper>
  );
};

export default BookQuickNavigation;
